(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4634],{

/***/ 19750:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/alternatives/bolosign-vs-zoho-sign",
      function () {
        return __webpack_require__(29297);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Alternatives_BolosignVsOthers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69319);




const BolosignVsZohosignData = {
    meta: {
        title: "BoloSign vs Zoho Sign 2024: Affordable vs Feature-Rich eSignature Solutions",
        description: "Compare BoloSign and Zoho Sign to find the best eSignature tool for your business needs. Explore cost, features, and benefits to make an informed choice."
    },
    image: {
        src: "bolosign-vs-zohosign.png",
        caption: "BoloSign vs. Zoho Sign: Compare and decide which eSignature tool best fits your business needs with our detailed breakdown.",
        alt: "Comparison graphic of BoloSign and Zoho Sign logos on a pastel background."
    },
    intro: {
        heading: "BoloSign vs. Zoho Sign: An In-Depth Analysis for 2024",
        description: "In the evolving landscape of digital documentation, electronic signatures have become indispensable for businesses seeking efficiency and compliance. Among the many options available, BoloSign and Zoho Sign emerge as two noteworthy platforms. This article provides a comprehensive comparison of these two e-signature solutions, emphasizing why BoloSign is a compelling choice for small businesses."
    },
    platforms: [
        {
            name: "BoloSign",
            heading: "What is BoloSign?",
            //   description:"",
            paragraphs: [
                "BoloSign is an eSignature platform designed to cater to businesses of all sizes, offering a cost-effective alternative to other eSignature solutions like DocuSign. It's priced to be about 90% cheaper than some of its major competitors, making it an attractive option for small to medium-sized enterprises and individuals looking for budget-friendly solutions.",
                "The platform provides a range of features that streamline the process of document management and signing. Users can create, send, and sign documents electronically, enhancing the efficiency of administrative tasks and reducing paper usage. BoloSign supports the creation of custom fields in contacts and the use of these fields in PDF templates, allowing for highly personalized documents."
            ],
            image: {
                src: "bolosign.png",
                alt: "BoloSign homepage featuring its eSignature platform tailored for small businesses.",
                caption: "BoloSign: The ultimate eSignature solution for small businesses. Enjoy unlimited signatures, templates, and team members at one fixed price—no extra costs."
            },
            keyFeatures: {
                heading: "Small businesses prefer BoloSign because",
                // subHeading:"",
                image: {
                    src: "bolosign-features.png",
                    alt: "Infographic highlighting key reasons small businesses prefer BoloSign, featuring attributes like security and customization.",
                    caption: "Discover why small businesses choose BoloSign: Offering cost-effectiveness, ease of use, security, customization, excellent customer support, and scalability."
                },
                features: [
                    {
                        title: "Cost-Effectiveness",
                        details: "BoloSign is significantly cheaper—about 90% less expensive than some of its major competitors."
                    },
                    {
                        title: "Simplicity and Ease of Use",
                        details: "BoloSign offers a straightforward and intuitive interface that does not require extensive training or technical expertise."
                    },
                    {
                        title: "Customization",
                        details: "BoloSign allows small businesses to tailor features to their specific needs, such as adding custom fields to documents."
                    },
                    {
                        title: "Security",
                        details: "Despite its affordability, BoloSign does not compromise on security. It offers robust security features, including encryption and options for OTP verification."
                    },
                    {
                        title: "Customer Support",
                        details: "BoloSign tends to provide more personalized customer support, which is beneficial for small businesses that value quick and direct assistance to resolve any issues they encounter."
                    },
                    {
                        title: "Scalability",
                        details: "As small businesses grow, their needs change. BoloSign is scalable, providing small businesses the flexibility to expand their usage of the platform at a pace that matches their growth."
                    },
                    {
                        details: "Additionally, BoloSign offers specialized tools like waivers and proposals, integrating the utilities of platforms like WaiverForever and Proposify. This expansion into different document types makes it a versatile tool for businesses looking to handle various forms of agreements and contracts."
                    }
                ]
            }
        },
        {
            name: "Zoho Sign",
            heading: "What is Zoho Sign?",
            description: "Zoho Sign is a digital signature service from the Zoho suite of online productivity tools and SaaS applications. It's designed to help businesses securely sign, send, and manage legally binding documents electronically. Zoho Sign is widely used across various industries due to its integration with other Zoho applications and its capabilities that support a wide range of business processes.",
            image: {
                src: "zohosign.png",
                alt: "Zoho Sign homepage showcasing their secure document signing solutions tailored for Indian businesses.",
                caption: "Zoho Sign: The trusted digital signature platform for Indian businesses, ensuring secure and legally recognized document signing. Start with a 14-day free trial!"
            },
            keyFeatures: {
                heading: "Here are some key features of Zoho Sign",
                // subHeading:"",
                image: {
                    src: "zohosign-features.png",
                    alt: "Infographic displaying three key features of Zoho Sign: Multi-platform use, Customization, and Document Management.",
                    caption: "Key Features of Zoho Sign: Embrace versatility with multi-platform use, tailor your experience with customization options, and streamline your operations with advanced document management."
                },
                features: [
                    {
                        title: "Multi-Platform Use",
                        details: "Zoho Sign is available on various platforms, including web browsers, iOS, and Android devices, enabling users to handle signing processes on the go."
                    },
                    {
                        title: "Customization",
                        details: "Users can add their branding to emails and signing pages to maintain a consistent look and feel with their other business materials."
                    },
                    {
                        title: "Document Management",
                        details: "Offers features for creating, sending, and tracking documents. Users can set up automated reminders for signees, customize signing orders, and receive notifications at every step of the signing process."
                    },
                    {
                        details: "Zoho Sign is particularly beneficial for small to medium-sized businesses looking for an efficient and economical solution for managing digital documents and signatures. It is part of Zoho's broader strategy to provide a comprehensive set of tools that cover various aspects of business management, from office suite operations to CRM, helping streamline operations and reduce costs."
                    }
                ]
            }
        }
    ],
    tableComparison: {
        heading: "BoloSign vs. Zoho Sign: A Feature Comparison",
        paragraph: "In conclusion, BoloSign stands out as a more accessible, equally secure, and highly affordable eSignature solution compared to Zoho Sign, particularly for businesses looking for straightforward yet powerful functionality without the need for broader business software suites. This makes BoloSign an ideal choice for budget-conscious businesses aiming for high efficiency in their document management processes.",
        headers: [
            "Feature",
            "BoloSign",
            "Zoho Sign"
        ],
        rows: [
            {
                feature: "Cost-Effectiveness",
                product1: "Significantly cheaper, about 90% less than competitors, including Zoho Sign.",
                product2: "Competitive, but potentially higher overall cost due to the need for additional Zoho apps."
            },
            {
                feature: "Integration",
                product1: "Easy integration with essential services, plus unique features from WaiverForever and Proposify.",
                product2: "Strong within the Zoho ecosystem; external integrations available but optimal for Zoho users."
            },
            {
                feature: "Security and Compliance",
                product1: "Advanced security with encryption, password protection, and OTP verification.",
                product2: "Complies with global standards; robust security features."
            },
            {
                feature: "Templates and Tools",
                product1: "Over 500 pre-built legal templates and a white-label option for reselling under its own branding.",
                product2: "Good range of templates; best utilized within the Zoho environment."
            },
            {
                feature: "Customization",
                product1: "High customization with custom fields for contacts and personalization in PDF templates.",
                product2: "Customization is available mainly for branding purposes."
            },
            {
                feature: "User Interface",
                product1: "Simple, intuitive interface designed for ease of use without sacrificing advanced features.",
                product2: "Functional and integrated within Zoho apps, potentially complex for non-Zoho users."
            },
            {
                feature: "Market Focus",
                product1: "Targeted at providing affordable, flexible solutions for SMEs.",
                product2: "Suitable for businesses embedded in or planning to use the Zoho suite."
            },
            {
                feature: "Special Features",
                product1: "Emphasis on versatile document types like waivers and proposals.",
                product2: "Document tracking, automated reminders, and multi-platform support."
            }
        ]
    },
    detailedComparison: {
        heading: "BoloSign vs. Zoho Sign: A Detailed Comparison",
        description: "When comparing BoloSign and Zoho Sign as eSignature solutions, it's important to highlight the distinctive advantages that BoloSign offers, particularly for those looking for cost-effectiveness, integration capabilities, and specific features tailored to small and medium-sized businesses. Here's a comparison that positions BoloSign favorably against Zoho Sign:",
        comparisons: [
            {
                title: "Cost Effectiveness",
                paragraphs: [
                    {
                        head: "BoloSign",
                        content: "Priced to be approximately 90% cheaper than its competitors, including Zoho Sign, making it an exceptionally budget-friendly option for all business sizes. This price advantage is particularly appealing to small businesses and startups that need to manage costs carefully."
                    },
                    {
                        head: "Zoho Sign",
                        content: "Offers a competitive pricing structure but is generally part of the broader Zoho ecosystem, which might require additional subscriptions to other Zoho apps for full functionality, potentially increasing the overall cost."
                    }
                ]
            },
            {
                title: "Integration and Flexibility",
                paragraphs: [
                    {
                        head: "BoloSign",
                        content: "While focused primarily on eSignature functionalities, BoloSign also integrates features from platforms like WaiverForever and Proposify, allowing for a versatile use of the platform beyond simple document signing, such as waivers and proposals. BoloSign's integration capabilities are designed to be straightforward, ensuring users can easily connect with other services they use."
                    },
                    {
                        head: "Zoho Sign",
                        content: "Integrates seamlessly within the Zoho ecosystem and with several external platforms. This is ideal for users already embedded in the Zoho infrastructure but might be less convenient for those not using other Zoho products."
                    }
                ]
            },
            {
                title: "Security and Compliance",
                paragraphs: [
                    {
                        head: "BoloSign",
                        content: "Offers robust security measures including advanced encryption, password protection, and OTP verification for signers, ensuring high levels of security and compliance with global standards."
                    },
                    {
                        head: "Zoho Sign",
                        content: "Also adheres to global compliance standards like GDPR, ESIGN, and UETA. Security features are strong, but BoloSign's additional focus on customizable security settings like OTP for signers provides an edge in user-controlled security."
                    }
                ]
            },
            {
                title: "Features and Usability",
                paragraphs: [
                    {
                        head: "BoloSign",
                        content: "Features over 500 pre-built legal templates and a white-label solution that allows businesses to resell the service under their branding. BoloSign emphasizes ease of use with a simple, intuitive interface that doesn't sacrifice advanced features for simplicity."
                    },
                    {
                        head: "Zoho Sign",
                        content: "Offers a range of features including document tracking, automated reminders, and multi-platform availability. While robust, the interface and feature set are best leveraged by those familiar with the Zoho suite."
                    }
                ]
            },
            {
                title: "Customization",
                paragraphs: [
                    {
                        head: "BoloSign",
                        content: "Provides significant customization options not just in terms of document handling but also in allowing users to create custom fields for contacts and use them in PDF templates, enhancing the personalization of documents."
                    },
                    {
                        head: "Zoho Sign",
                        content: "Customization features are available, particularly with email and signing page branding, but BoloSign’s offerings are more tailored towards providing a bespoke user experience."
                    }
                ]
            },
            {
                title: "Market Focus",
                paragraphs: [
                    {
                        head: "BoloSign",
                        content: "Specifically targets affordability and flexibility, making it highly suitable for SMEs that require efficient, cost-effective solutions without the need for extensive additional tools."
                    },
                    {
                        head: "Zoho Sign",
                        content: "While effective for businesses of all sizes, it is particularly beneficial for those already invested in the Zoho ecosystem."
                    }
                ]
            }
        ]
    },
    useCases: {
        heading: "When to Choose BoloSign vs. Zoho Sign",
        subHeading: "When evaluating eSignature solutions, choosing between BoloSign and Zoho Sign depends on specific business needs, workflows, and strategic goals. Here are some use cases that illustrate when one might be preferred over the other:",
        scenarios: [
            {
                title: "When to Choose BoloSign:",
                image: {
                    src: "choose-bolosign.png",
                    alt: "Infographic explaining when to choose BoloSign, highlighting budget-conscious startups, quick implementation, and customizable document processes.",
                    caption: "When to Choose BoloSign: 1. Budget-Conscious Startups and Small Businesses, 2. Businesses Needing Simple and Quick Implementation, 3. Organizations Seeking Customizable Document Processes."
                },
                cases: [
                    {
                        title: "Budget-Conscious Startups and Small Businesses",
                        paragraphs: [
                            {
                                head: "Scenario",
                                content: "A startup is managing tight financial constraints but needs an efficient way to handle contracts and agreements."
                            },
                            {
                                head: "Why BoloSign",
                                content: "BoloSign's affordability makes it an ideal choice for businesses with limited budgets, offering essential eSignature functionalities without a significant financial burden."
                            }
                        ]
                    },
                    {
                        title: "Businesses Needing Simple and Quick Implementation",
                        paragraphs: [
                            {
                                head: "Scenario",
                                content: "A small business with no dedicated IT team needs an eSignature solution that can be set up quickly and used easily without extensive training."
                            },
                            {
                                head: "Why BoloSign",
                                content: "BoloSign's user-friendly interface and straightforward functionality allow for easy adoption, reducing the need for technical expertise and extensive training sessions."
                            }
                        ]
                    },
                    {
                        title: "Organizations Seeking Customizable Document Processes",
                        paragraphs: [
                            {
                                head: "Scenario",
                                content: "A consulting firm requires custom fields in their contract templates to personalize documents based on client-specific data."
                            },
                            {
                                head: "Why BoloSign",
                                content: "BoloSign provides extensive customization options, including the ability to add custom fields and personalize PDF templates, making it suitable for businesses that require tailored document workflows."
                            }
                        ]
                    }
                ]
            },
            {
                title: "When to Choose Zoho Sign:",
                image: {
                    src: "choose-zohosign.png",
                    alt: "Infographic showing when to choose Zoho Sign for startups, quick processes, and customizable workflows.",
                    caption: "When to Choose Zoho Sign: Ideal for budget-conscious startups, businesses needing a quick and simple process, and organizations seeking customizable document workflows."
                },
                cases: [
                    {
                        title: "Businesses Heavily Integrated with Zoho Products",
                        paragraphs: [
                            {
                                head: "Scenario",
                                content: "An organization already uses multiple Zoho applications like Zoho CRM, and Zoho Books, and needs an eSignature tool that integrates seamlessly."
                            },
                            {
                                head: "Why Zoho Sign",
                                content: "Zoho Sign offers deep integration with other Zoho products, making it a convenient choice for users looking to maintain a unified platform for all their business operations."
                            }
                        ]
                    },
                    {
                        title: "Companies Needing Advanced Workflow Integrations",
                        paragraphs: [
                            {
                                head: "Scenario",
                                content: "A medium-sized enterprise requires complex signing workflows that integrate with their CRM and project management tools."
                            },
                            {
                                head: "Why Zoho Sign",
                                content: "Zoho Sign supports extensive integration capabilities with various third-party applications and services, which is ideal for businesses needing advanced workflow integrations."
                            }
                        ]
                    }
                ]
            }
        ]
    },
    faqData: {
        heading: "FAQ",
        faqs: [
            {
                faqQuestion: "What are the key differences between BoloSign and Zoho Sign?",
                faqAnswer: "\n            <p>\n              BoloSign offers exceptional cost-effectiveness, a simple and intuitive interface, and extensive customization options tailored for small and medium-sized businesses. It also provides a unique feature set that includes over 500 legal templates and specialized tools like waivers and proposals. Zoho Sign, on the other hand, excels in deep integration within the Zoho ecosystem and supports advanced workflow integrations, making it suitable for businesses heavily using Zoho products.\n            </p>\n          "
            },
            {
                faqQuestion: "How does the pricing of BoloSign compare to Zoho Sign?",
                faqAnswer: "\n            <p>\n              BoloSign is priced to be about 90% cheaper than major competitors, including Zoho Sign. This makes it an exceptionally budget-friendly option for small businesses and startups. Zoho Sign offers competitive pricing, but for full functionality, it might require additional subscriptions to other Zoho apps, which could increase overall costs.\n            </p>\n          "
            },
            {
                faqQuestion: "Can I use BoloSign if I am already using other Zoho products?",
                faqAnswer: "\n            <p>\n              Yes, BoloSign is designed to integrate smoothly with essential services and platforms, so you can use it alongside other business tools, including those from Zoho. However, BoloSign's standalone features and pricing make it a compelling choice even without additional integrations.\n            </p>\n          "
            },
            {
                faqQuestion: "What types of businesses benefit the most from using BoloSign?",
                faqAnswer: "\n            <p>\n              BoloSign is especially beneficial for startups, small and medium-sized businesses, or any organization looking for a cost-effective, easy-to-use eSignature solution that doesn’t require extensive IT resources. It’s also ideal for companies that need customizable document processes and a straightforward, no-frills approach to electronic signatures.\n            </p>\n          "
            },
            {
                faqQuestion: "What security features does BoloSign offer?",
                faqAnswer: "\n            <p>\n              BoloSign provides robust security measures, including advanced encryption, password protection for documents, and OTP verification for signers. These features ensure that all transactions are secure and compliant with international legal standards.\n            </p>\n          "
            }
        ]
    },
    conclusion: {
        heading: "Conclusion",
        paragraphs: [
            "When selecting an eSignature solution, the choice between BoloSign and Zoho Sign depends on your specific business needs, budget constraints, and existing software ecosystem. BoloSign stands out as a highly cost-effective, easy-to-use platform with extensive customization options, making it ideal for small to medium-sized businesses that prioritize affordability and simplicity in their digital document processes. It provides an array of features tailored to enhance usability and efficiency without requiring significant IT resources.",
            "On the other hand, Zoho Sign is best suited for businesses that are already integrated into the Zoho ecosystem and require advanced document management and workflow integrations. Its seamless compatibility with other Zoho applications makes it a convenient choice for those who prefer a unified software environment.",
            "Ultimately, both BoloSign and Zoho Sign offer robust, secure, and compliant eSignature solutions. The decision should be guided by evaluating how each platform aligns with your operational workflows, integration needs, and financial planning. By understanding the strengths and offerings of each, businesses can choose an eSignature solution that not only meets their current requirements but also supports their growth and adaptation in an increasingly digital world."
        ]
    }
};
const BolosignVsZohosign = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full md:mt-20 mt-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: BolosignVsZohosignData.meta.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: BolosignVsZohosignData.meta.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "Boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "publisher",
                        content: "BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "DocuSign, BoloSign, eSignature, electronic signature, digital signature, eSignature comparison, DocuSign vs BoloSign, eSignature solutions, small business eSignature"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/signature/alternatives/bolosign-vs-zoho-sign/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: BolosignVsZohosignData.meta.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/signature/alternatives/bolosign-vs-zoho-sign/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: BolosignVsZohosignData.meta.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/alternatives/bolosign-vs-zoho-sign/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Alternatives_BolosignVsOthers__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                bolosignVsOthersData: BolosignVsZohosignData
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BolosignVsZohosign);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9319,9774,2888,179], function() { return __webpack_exec__(19750); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);